<script setup lang="ts">
import type { ListingEmptyStateProps } from './index';
import StatusMessageDisplay from '../StatusMessageDisplay/StatusMessageDisplay.vue';
import { cn } from '@/utils';

const props = withDefaults(defineProps<ListingEmptyStateProps>(), {
	badgesVariant: 'primary-outline',
	showBadges: true
});
</script>

<template>
	<div>
		<StatusMessageDisplay v-bind="props">
			<template #title>
				<slot name="title" />
			</template>
			<template #description>
				<slot name="description" />
			</template>
			<template #icon>
				<IconMaterialSymbolsLightSearch :class="cn('size-7 text-white')" />
			</template>
		</StatusMessageDisplay>

		<div
			v-if="showBadges"
			:class="
				cn(
					'flex flex-wrap items-center justify-center gap-3 pt-2',
					badgesWrapperClasses
				)
			"
		>
			<!-- 
				** A listagem de filtros aplicados está hardcoded até que possamos implementar filtros **
			-->
			<Badge
				v-for="i in 3"
				:key="i"
				:variant="badgesVariant"
				:class="
					cn(
						'flex w-min cursor-pointer items-center justify-center gap-2 text-nowrap px-2 py-1 text-xs font-medium leading-normal text-primary',
						badgesClasses
					)
				"
			>
				Quartos: +5

				<IconMaterialSymbolsLightClose class="size-5 text-primary" />
			</Badge>
		</div>
	</div>
</template>
